import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules';
import createPersistedState from 'vuex-persistedstate'
import Account from '../services/Account'
import Notification from '../services/Notification'
import Guests from '../services/Guests'
import Statistics from '../services/Statistics'
import Posts from '../services/Posts'
import Invoices from '../services/Invoices'
import Config from '../services/Configuration'
import Company from '../services/Company'
import Messages from '../services/Messages'
import Aps from '../services/Aps'
import router from '../router'
import to from 'await-to-js'
import {EventBus} from "./event-bus";

Vue.use(Vuex);

const index = new Vuex.Store({
  modules,
  plugins: [createPersistedState()],
  state: {
    error: {},
    globalLoading: false,
    account: {},
    company: {},
    CompanyId: (parseInt(localStorage.getItem('CompanyId'))) ? parseInt(localStorage.getItem('CompanyId')) : 1,
    companies: [],
    token: null,
    guests: [],
    aps: [],
    resellerAps: [],
    countryGuestsStats: [],
    languageGuestsStats: [],
    newGuestsMonthlyStats: {
      values: [],
      time: [],
    },
    posts: [],
    gifts: [],
    billboardPosts: [],
    invoices: [],
    config: {},
    package: {},
    galleryMedias: [],
    selectedImages: [],
    countries: [],
    notifications: [],
    languages: [],
    templates: [],
    appLanguage: 'english',
    initialized: false,
    clients: [],
  },
  getters: {
    route: state => state.route,
    error: state => state.error,
    globalLoading: state => state.globalLoading,
    account: state => state.account,
    token: state => state.token,
    guests: state => state.guests,
    aps: state => state.aps,
    resellerAps: state => state.resellerAps,
    countryGuestsStats: state => state.countryGuestsStats,
    languageGuestsStats: state => state.languageGuestsStats,
    newGuestsMonthlyStats: state => state.newGuestsMonthlyStats,
    posts: state => state.posts,
    gifts: state => state.gifts,
    billboardPosts: state => state.billboardPosts,
    invoices: state => state.invoices,
    config: state => state.config,
    package: state => state.package,
    galleryMedias: state => state.galleryMedias,
    selectedImages: state => state.selectedImages,
    notifications: state => state.notifications,
    countries: state => state.countries,
    languages: state => state.languages,
    appLanguage: state => state.appLanguage,
    templates: state => state.templates,
    initialized: state => state.initialized,
    companies (state, getters) {
      if (state.account.role === 'reseller') {
        return getters.clients;
      } else {
        return state.companies;
      }
    },
    clients: (state) => state.clients,
    company(state, getters) {
      if (state.account.role === 'admin') {
        if (getters.companies && getters.companies.length > 0) {
          return getters.companies.filter(company => parseInt(company.id) === parseInt(state.CompanyId))[0] || { links: {} };
        }
        return { links: {} };
      } else {
        return state.company;
      }
    },
    showBillboard (state, getters) {
      if (getters.company.config) return !(!getters.company.config.using_billboard && getters.account.role === 'client');
      return true;
    },
    hasRegistration (state, getters) {
      if (getters.company.config && getters.account) return !(!getters.company.config.login_option && getters.account.role === 'client');
      return true;
    },
    companyTypes () {
      return ['restaurant', 'cafe', 'club', 'barber', 'beauty_center', 'shisha', 'coworking', 'mall', 'hotel', 'taxi', 'boutique', 'supermarket', 'shoppingcenter', 'bakery', 'museum'];
    }
  },
  actions: {
    // Admin
    async fetchCompanies({state, commit}) {
      let [err, response] = await to(Company.getAll());
      if (err) this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setCompanies', response.data.companies);
      }
    },

    async fetchAps ({state, commit}) {
      let [err, response] = await to(Aps.getAll());
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setAps', response.data.aps)
      }
    },

    async fetchResellerAps ({state, commit}) {
      let [err, response] = await to(Aps.getByReseller(state.account.reseller.id));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setResellerAps', response.data.aps)
      }
    },


    async fetchNotifications({state, commit}) {
      let [err, response] = await to(Notification.getAll());
      if (err) this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setNotifications', response.data.notifications);
      }
    },
    async fetchAccount({state, commit}) {
      /*
       Account
      */
      const [err, response] = await to(Account.getUserData());
      if (err) return this._vm.errorSnack(err);

      if (response.data.success) {
        commit('setAccount', response.data.account);
        if (state.account.role === 'admin' || state.account.role === 'reseller') {
          localStorage.setItem('CompanyId', parseInt(localStorage.getItem('CompanyId')) || state.account.CompanyId);
        } else localStorage.removeItem('CompanyId');

        if(state.account.role === 'reseller') {
          let [err, company] = await to(Company.getByReseller(state.account.reseller.id));
          if (err) return this._vm.errorSnack(err);
          if (company.data.success) {
            commit('setClients', company.data.companies);
          }
        }

        let [err, company] = await to(Company.getById(parseInt(localStorage.getItem('CompanyId')) || state.account.CompanyId));
        if (err) return this._vm.errorSnack(err);
        if (company.data.success) {
          commit('setCompany', company.data.company);
        }
        commit('setInitialized', true)
      }
    },
    async fetchLanguageGuestsStats({state, commit, getters}) {
      /*
       Language Guests Statistics
      */
      const [err, response] = await to(Statistics.getLanguageGuestsStats({id: getters.company.id}));
      if (err) console.log(err);
      if (response.data.success) {
        commit('setLanguageGuestsStats', response.data.stats)
      }
    },
    async fetchCountryGuestsStats({state, commit, getters}) {
      /*
       Country Guests Statistics
      */
      const [err, response] = await to(Statistics.getCountryGuestsStats({id: getters.company.id}));
      if (err) console.log(err);
      if (response.data.success) {
        commit('setCountryGuestsStats', response.data.stats)
      }
    },
    async fetchNewGuestsMonthlyStats({state, commit, getters}) {
      /*
        New Guests Statistics
       */
      const [err, response] = await to(Statistics.newGuestsMonthlyStats({id: getters.company.id}))
      if (err) console.log(err);
      if (response.data.success) {
        commit('setNewGuestsMonthlyStats', response.data.data)
      }
    },
    async fetchGuests({state, commit, getters}) {
      /*
        Guests
      */
      const [err, response] = await to(Guests.fetchGuests(getters.company.id));
      if (err) console.log(err);
      if (response.data.success) {
        commit('setGuests', response.data.users)
      }
    },
    async fetchPosts({state, commit, getters}) {
      /*
       Posts
      */
      const [err, response] = await to(Posts.fetchPosts({id: getters.company.id, offset: 0, amount: 100 }));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setPosts', response.data.posts)
      }
    },
    async fetchGifts({state, commit, getters}) {
      /*
       Gifts
      */
      const [err, response] = await to(Posts.fetchGifts({
        CompanyId: getters.company.id,
        offset: 0,
        amount: 100
      }));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setGifts', response.data.giftPosts)
      }
    },
    async fetchBillboardPosts({state, commit, getters}) {
      /*
       Billboard Posts
      */
      const [err, response] = await to(Posts.fetchBillboardPosts({id: getters.company.id}));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setBillboardPosts', response.data.posts)
      }
    },
    async fetchGalleryMedias({state, commit, getters}) {
      /*
       Gallery Images
      */
      const [err, response] = await to(Posts.fetchMedias({companyId: getters.company.id}));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setgalleryMedias', response.data.medias)
      }
    },
    async fetchInvoices({state, commit, getters}) {
      /*
       Invoices
      */
      const [err, response] = await to(Invoices.fetchInvoices({id: getters.company.id}));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setInvoices', response.data.invoices)
      }
    },
    async fetchPackage({state, commit, getters}) {
      /*
       Package
      */
      const [err, response] = await to(Company.getPackage({CompanyId: getters.company.id}));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setPackage', response.data.package)
      }
    },
    async fetchConfig({state, commit, getters}) {
      /*
       Configurations
      */
      const [err, response] = await to(Config.getByCompanyId(getters.company.id));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setConfig', response.data.config)
      }
    },
    async fetchLanguages({state, commit}) {
      /* Languages */
      const [err, response] = await to(Config.getLanguages());
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setLanguages', response.data.languages)
      }
    },
    async fetchCountries({state, commit, dispatch}) {
      /* Countries */
      const [err, response] = await to(Config.getCountries());
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setCountries', response.data.countries)
      }
    },
    async fetchTemplates({state, commit, getters}) {
      const [err, response] = await to(Messages.getMessageTemplates(getters.company.id));
      if (err) return this._vm.errorSnack(err);
      if (response.data.success) {
        commit('setMessageTemplates', response.data.templates)
      }
    },
    setSelectedMedias({commit}, selectedImages) {
      commit('setSelectedMedias', selectedImages)
    },
    setLanguage({commit}, appLanguage) {
      commit('setLanguage', appLanguage)
    },
    async logout(state) {
      console.log('HEHE');
      state.account = null
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      localStorage.removeItem('CompanyId')

      router.push('/auth/');
    },
    setToken({state, commit}, token) {
      commit('setToken', token)
    },
    setLoading({commit}, loading){
      commit('setLoading', loading);
    }
  },
  mutations: {
    setLoading (state, loading) {
      state.globalLoading = loading
    },
    setMessageTemplates(state, templates) {
      state.templates = templates;
    },
    error(state, err) {
      state.error = err;
    },
    setAccount(state, account) {
      state.account = account
    },
    setGuests(state, guests) {
      guests.map((e) => {
        e.contact = (e.phone) ? e.phone : e.email
        if (e.gender === 'M') e.gender = 'Male'
        else if (e.gender === 'F') e.gender = 'Female'
        else e.gender = 'Unknown'
      });
      state.guests = guests
    },
    setCompany(state, company) {
      if (company && !company.links) company.links = {};
      EventBus.$emit('companyUpdated', company);
      state.company = company
    },
    setLanguageGuestsStats(state, stats) {
      state.languageGuestsStats = stats
    },
    setCountryGuestsStats(state, stats) {
      state.countryGuestsStats = stats
    },
    setNewGuestsMonthlyStats(state, stats) {
      state.newGuestsMonthlyStats = stats
    },
    setToken(state, token) {
      state.token = token
    },
    setPosts(state, posts) {
      state.posts = posts
    },
    setGifts(state, gifts) {
      state.gifts = gifts
    },
    setBillboardPosts(state, billboardPosts) {
      state.billboardPosts = billboardPosts
    },
    setConfig(state, config) {
      state.config = config
    },
    setInvoices(state, invoices) {
      state.invoices = invoices
    },
    setSelectedMedias(state, selectedImages) {
      state.selectedImages = selectedImages
    },
    setgalleryMedias(state, promotionPictures) {
      state.galleryMedias = promotionPictures
    },
    setLanguage(state, appLanguage) {
      state.appLanguage = appLanguage
    },
    setPackage(state, pack) {
      state.package = pack
    },
    setInitialized(state, initialized) {
      state.initialized = initialized
    },
    setLanguages(state, languages) {
      state.languages = languages
    },
    setCountries(state, countries) {
      state.countries = countries
    },
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
    setAps (state, aps) {
      aps.forEach(ap => ap.selected = false);
      state.aps = aps
    },

    // Admin
    setCompanies(state, companies) {
      if (Array.isArray(companies)) companies.forEach(c => { if (c && !c.links) c.links = {}; });
      state.companies = companies;
    },
    setCompanyId(state, CompanyId) {
      state.CompanyId = CompanyId;
      if (state.account.role === 'admin' || state.account.role === 'reseller')
        localStorage.setItem('CompanyId', CompanyId);
    },

    // Reseller
    setClients(state, clients) {
      state.clients = clients;
    },
    setResellerAps (state, aps) {
      aps.forEach(ap => ap.selected = false);
      state.resellerAps = aps
    },
  }
});

export default index
